import { AnyAction } from 'redux';
import { distributorWise } from '../../components/dashboard/topDistributorsRM';
import { DistributorLeaderboardResponse } from '../types/api-types';
import { GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS } from '../types/application';
import { LOGOUT_SUCCESS } from '../types/auth';

function topDistributorReducer(
  state = distributorWise,
  action: AnyAction
): DistributorLeaderboardResponse {
  switch (action.type) {
    case GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS:
      return {
        days: action.body?.days ?? state.days,
        data: action.body?.data ?? [],
      };
    case LOGOUT_SUCCESS: {
      return distributorWise;
    }
    default:
      return state;
  }
}

export default topDistributorReducer;
